const API_BASE = process.env.REACT_APP_API_BASE_URL;

const billingRequest = {
	/* ──────────────────────────────────────────────
	    1) Setup Billing (create subscription in Paddle)
	   ────────────────────────────────────────────── */
	async billingSetup({ shopId, userId, accessToken, seats = 1 }) {
		if (!shopId) throw new Error("Missing shopId in billingSetup()");
		if (!userId) throw new Error("Missing userId in billingSetup()");
		if (!accessToken) throw new Error("Missing accessToken in billingSetup()");

		const res = await fetch(`${API_BASE}/billing/setup/${shopId}`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${accessToken}`,
			},
			body: JSON.stringify({
				userId,
				seats, // allows future multi-seat plans
			}),
		});

		if (!res.ok) {
			let errorMessage = await res.text().catch(() => "Unknown error");
			throw new Error(`Failed to setup billing: ${errorMessage}`);
		}

		return res.json();
	},

	async billingSync(shopId) {
		const res = await fetch(`${API_BASE}/billing/sync/${shopId}`);

		if (!res.ok) throw new Error("Failed to sync billing");

		return res.json(); // subscriptionState, seats, nextBilling etc
	},


	async startBilling(shopId, accessToken) {
		const res = await fetch(`${API_BASE}/billing/launch/${shopId}`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${accessToken}`,
			},
		});

		if (!res.ok) {
			const text = await res.text();
			throw new Error(`Failed to start billing: ${text}`);
		}

		return res.json();
	},

	async billingStatus(shopId) {
        if (!shopId) throw new Error("Missing shopId in billingStatus()");

        const res = await fetch(`${API_BASE}/billing/status/${shopId}`);

        if (!res.ok) {
            const text = await res.text().catch(() => "Unknown error");
            throw new Error(`Failed to fetch billing status: ${text}`);
        }

        return res.json();
        // {
        //   active: boolean,
        //   subscriptionActive: boolean,
        //   status: string | null,
        //   billingStatus: string | null
        // }
    },

	/* ──────────────────────────────────────────────
	    4) Update seat count (charge for staff)
	   ────────────────────────────────────────────── */
	async updateSeats(shopId, newSeatCount, accessToken) {
		const res = await fetch(`${API_BASE}/billing/seats/${shopId}`, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${accessToken}`,
			},
			body: JSON.stringify({ seats: newSeatCount }),
		});

		if (!res.ok) {
			const text = await res.text();
			throw new Error(`Failed to update seats: ${text}`);
		}

		return res.json(); // returns updated billing data
	},

	/* ──────────────────────────────────────────────
	5) Apply referral code
	────────────────────────────────────────────── */
	async applyReferral(shopId, referralCode, accessToken) {
		const res = await fetch(`${API_BASE}/billing/referral/apply/${shopId}`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${accessToken}`,
			},
			body: JSON.stringify({ referralCode }),
		});

		if (!res.ok) {
			const text = await res.text();
			throw new Error(`Failed to apply referral code: ${text}`);
		}

		return res.json(); // updated discount, nextBillingDate, etc
	},

	async getBillingInfo(shopId, accessToken) {
		const res = await fetch(`${API_BASE}/billing/info/${shopId}`, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${accessToken}`,
			},
		});

		if (!res.ok) {
			const text = await res.text();
			throw new Error(`Failed to fetch billing info: ${text}`);
		}

		return res.json(); // { billing: { customer, subscription, invoices } }
	},

	/* ──────────────────────────────────────────────
    6) Get Referral Dashboard (code + history)
   ────────────────────────────────────────────── */
	async getReferralDashboard(userId, accessToken) {
		const res = await fetch(`${API_BASE}/referrals/dashboard/${userId}`, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${accessToken}`,
			},
		});

		if (!res.ok) {
			const text = await res.text();
			throw new Error(`Failed to load referral dashboard: ${text}`);
		}

		return res.json();
		// { referralCode, referrals: [ ... ] }
	},

	/* ──────────────────────────────────────────────
    7) Generate Referral Code
   ────────────────────────────────────────────── */
	async generateReferralCode({ userId, accessToken }) {
		const res = await fetch(`${API_BASE}/referrals/generate`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${accessToken}`,
			},
			body: JSON.stringify({ userId }),
		});

		if (!res.ok) {
			const text = await res.text();
			throw new Error(`Failed to generate referral code: ${text}`);
		}

		return res.json();
		// { referralCode: "ABC123" }
	},
};

export default billingRequest;
